import { useContext } from "react";
import { AuthenticationContext } from "../../components/authentication/AuthenticationProvider";

export const useAuth = () => useContext(AuthenticationContext)!;
